import { FilterBaseOption, FilterOptionGroup } from '../types';

const formatFilterOptionItem = (opt: Record<string, unknown>, labelKey: string): FilterBaseOption => {
  return {
    value: opt.id as string,
    label: opt[labelKey] as string,
    color: opt.color as string | undefined,
  };
};

// Function overloads to infer the return type based on the presence of groupName
export function formatFilterOptionList(
  option: Record<string, unknown>[],
  labelKey: string,
  groupName: string,
): FilterOptionGroup;

export function formatFilterOptionList(option: Record<string, unknown>[], labelKey: string): FilterBaseOption[];

// Implementation
export function formatFilterOptionList(
  option: Record<string, unknown>[],
  labelKey: string,
  groupName?: string,
): FilterOptionGroup | FilterBaseOption[] {
  if (groupName) {
    return {
      groupName,
      options: option.map((opt) => formatFilterOptionItem(opt, labelKey)),
    };
  }
  return option.map((opt) => formatFilterOptionItem(opt, labelKey));
}
